import React, { useState, useEffect } from 'react';
if (typeof window !== 'undefined' && !Array.isArray(window._awev)) {
  window._awev = [];
}
function loadAddwishScript(id) {
  if (typeof window === 'undefined') {
    return;
  }
  var aws = document.createElement('script');
  aws.type = 'text/javascript';
  if (typeof aws.async != 'undefined') {
    aws.async = true;
  }
  aws.src = (window.location.protocol == 'https:' ? 'https://d1pna5l3xsntoj.cloudfront.net' : 'http://cdn.addwish.com') + ("/scripts/company/awAddGift.js#" + id);
  var s = document.getElementsByTagName('script')[0];
  s && s.parentNode && s.parentNode.insertBefore(aws, s);
}
function checkScriptLoadedOrThrow() {
  if (typeof window === 'undefined') {
    throw new Error('Addwish is client only');
  }
  if (!window.ADDWISH_PARTNER_NS) {
    throw new Error('Addwish client not loaded');
  }
}
function reloadAddwish() {
  if (isAddwishLoaded()) {
    window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.reload();
  }
}
function isAddwishLoaded() {
  return typeof window !== 'undefined' && !!window.ADDWISH_PARTNER_NS;
}
function setAddwishCart(cart) {
  return new Promise(function (resolve, reject) {
    try {
      checkScriptLoadedOrThrow();
      window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.setCart(cart, function () {
        resolve();
      });
    } catch (err) {
      reject(err);
    }
  });
}
function clearAddwishCart() {
  return new Promise(function (resolve, reject) {
    try {
      checkScriptLoadedOrThrow();
      window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.clearCart(resolve);
    } catch (err) {
      reject(err);
    }
  });
}
function addAddwishProductToCart(productNumber) {
  try {
    checkScriptLoadedOrThrow();
    window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.addProduct({
      productNumber: productNumber
    });
  } catch (err) {
    console.log(err);
  }
}
function fetchAddwishRecommendations(_ref) {
  var boxes = _ref.boxes,
    callback = _ref.callback,
    errorCallback = _ref.errorCallback;
  if (typeof window !== 'undefined') {
    requestAnimationFrame(function () {
      return window._awev.push(['bind', 'context_ready', function () {
        var _window, _window$ADDWISH_PARTN;
        (_window = window) === null || _window === void 0 ? void 0 : (_window$ADDWISH_PARTN = _window.ADDWISH_PARTNER_NS) === null || _window$ADDWISH_PARTN === void 0 ? void 0 : _window$ADDWISH_PARTN.api.recom.load(boxes, {
          format: 'json'
        }, callback, errorCallback);
      }]);
    });
  }
}
function _trackCart(args, _context) {
  var _args$cart;
  var productNumbers = args && args.cart && args.cart.items && args.cart.items.map(function (product) {
    return product && product.articleNumber;
  }) || [];
  // We grab cart id from local storage before it's removed (when emptying the cart)
  var cartId = (args === null || args === void 0 ? void 0 : (_args$cart = args.cart) === null || _args$cart === void 0 ? void 0 : _args$cart.id) || window.localStorage.getItem('cartId');
  if (!(args !== null && args !== void 0 && args.cart)) {
    return;
  }
  if (productNumbers.length > 0) {
    var _args$cart2, _args$cart2$productTo;
    return setAddwishCart({
      productNumbers: productNumbers,
      total: (args === null || args === void 0 ? void 0 : (_args$cart2 = args.cart) === null || _args$cart2 === void 0 ? void 0 : (_args$cart2$productTo = _args$cart2.productTotal) === null || _args$cart2$productTo === void 0 ? void 0 : _args$cart2$productTo.incVat) + '',
      url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cartId
    });
  }
  if (cartId && productNumbers.length === 0) {
    return clearAddwishCart();
  }
  return;
}
var addwishTracker = function addwishTracker(id) {
  return {
    name: 'addwish',
    initBrowser: function initBrowser() {
      loadAddwishScript(id);
    },
    consent: function consent() {
      loadAddwishScript(id);
    },
    trackPageView: function trackPageView() {
      // Await react-helmet updates to the DOM since AddWish reads URL from og:url
      requestAnimationFrame(function () {
        return reloadAddwish();
      });
    },
    trackCart: function trackCart(props, context) {
      _trackCart(props);
    },
    trackCartCheckout: function trackCartCheckout(props, context) {
      _trackCart(props);
    },
    trackProduct: function trackProduct(_ref2) {
      var action = _ref2.action,
        product = _ref2.product;
      switch (action) {
        // Rest is tracked via trackcart changes
        case 'click':
          {
            if (product !== null && product !== void 0 && product.addwishData) {
              var _product$addwishData, _window2, _window2$ADDWISH_PART;
              var addwishUrl = new URL(product === null || product === void 0 ? void 0 : (_product$addwishData = product.addwishData) === null || _product$addwishData === void 0 ? void 0 : _product$addwishData.url);
              var parts = addwishUrl.hash.slice(1).split('=');
              (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$ADDWISH_PART = _window2.ADDWISH_PARTNER_NS) === null || _window2$ADDWISH_PART === void 0 ? void 0 : _window2$ADDWISH_PART.api.tracking.track_click(parts[1]);
            }
            break;
          }
      }
    }
  };
};

/**
 * @deprecated
 */
var AddwishProvider = function AddwishProvider(_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, children);
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
var UnexpectedResponseError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(UnexpectedResponseError, _Error);
  function UnexpectedResponseError(message, _ref) {
    var _this;
    var recommendationBoxId = _ref.recommendationBoxId,
      items = _ref.items;
    _this = _Error.call(this, message) || this;
    console.error(message, {
      items: items,
      recommendationBoxId: recommendationBoxId
    });
    return _this;
  }
  return UnexpectedResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function validateResponseBox(_ref2) {
  var items = _ref2.items,
    recommendationBoxId = _ref2.recommendationBoxId;
  if (!Array.isArray(items)) {
    throw new UnexpectedResponseError("Result property wasn't an array", {
      items: items,
      recommendationBoxId: recommendationBoxId
    });
  }
  if (items.length > 0 && typeof items[0].productNumber !== 'string') {
    throw new UnexpectedResponseError('"productNumber" needs to be a string', {
      items: items,
      recommendationBoxId: recommendationBoxId
    });
  }
}
var LoadingState;
(function (LoadingState) {
  LoadingState["LOADING"] = "LOADING";
  LoadingState["ERROR"] = "ERROR";
  LoadingState["SUCCESS"] = "SUCCESS";
})(LoadingState || (LoadingState = {}));
function useAddwish(_ref3) {
  var boxes = _ref3.boxes,
    pageLoaded = _ref3.pageLoaded;
  var initialAddWishResponseBoxItems = {};
  Object.keys(boxes).forEach(function (recommendationBoxId) {
    initialAddWishResponseBoxItems[recommendationBoxId] = {
      items: [],
      loading: LoadingState.LOADING
    };
  });
  var _useState = useState(initialAddWishResponseBoxItems),
    addWishResponseBoxItems = _useState[0],
    setAddWishResponseBoxItems = _useState[1];
  var _useState2 = useState(false),
    dataFetched = _useState2[0],
    setDataFetched = _useState2[1];
  useEffect(function () {
    if (dataFetched) {
      return;
    } else if (pageLoaded) {
      fetchData();
    }
    function fetchData() {
      var callback = function callback(recommendationBoxId, items) {
        validateResponseBox({
          items: items,
          recommendationBoxId: recommendationBoxId
        });
        setAddWishResponseBoxItems(function (state) {
          var _extends2;
          return _extends({}, state, (_extends2 = {}, _extends2[recommendationBoxId] = {
            items: items,
            loading: LoadingState.SUCCESS
          }, _extends2));
        });
      };
      var errorCallback = function errorCallback(recommendationBoxId, _tag, errorCode) {
        console.error('fetchAddwishRecommendations error', errorCode);
        setAddWishResponseBoxItems(function (state) {
          var _extends3;
          return _extends({}, state, (_extends3 = {}, _extends3[recommendationBoxId] = {
            items: [],
            loading: LoadingState.ERROR
          }, _extends3));
        });
      };
      fetchAddwishRecommendations({
        boxes: boxes,
        callback: callback,
        errorCallback: errorCallback
      });
      setDataFetched(true);
    }
  }, [boxes]);
  return {
    addWishResponseBoxItems: addWishResponseBoxItems
  };
}
export { AddwishProvider, LoadingState, addAddwishProductToCart, addwishTracker, fetchAddwishRecommendations, isAddwishLoaded, loadAddwishScript, reloadAddwish, setAddwishCart, _trackCart as trackCart, useAddwish, validateResponseBox };
//# sourceMappingURL=flight-addwish.esm.js.map